import React from "react";

export function Icon({ type }) {
    return <i className={'icon icon-' + type} />
}
